module.exports = __webpack_public_path__ + "static/media/circle_white.8bbaf891.svg";